import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericChartCardComponent } from 'src/app/shared/component/generic-card/generic-chart-card/generic-chart-card.component';
import { BarChartComponent } from 'src/app/shared/component/charts/bar-chart/bar-chart.component';
import { DateRangeComponent } from 'src/app/shared/component/date-range/date-range.component';
import { TranslateModule } from '@ngx-translate/core';
import { BaseChart, DashboardReportsCharts } from 'src/app/core/data/model';
import { ChartCardCallerCallBack } from 'src/app/shared/bloc/chart-card-bloc';
import { FilterFormGroup } from 'src/app/shared/component/base-filter-component/base-filter-component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { map, takeUntil } from 'rxjs';
import { DashboardRepository } from 'src/app/core/data/repository';
import { MatIconModule } from '@angular/material/icon';
import { ChartCardHeaderDataComponent } from 'src/app/shared/component/generic-card/chart-card-header-data/chart-card-header-data.component';
import { chartFilters, ChartHeaderData } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-teachers-report-chart',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    GenericChartCardComponent,
    BarChartComponent,
    DateRangeComponent,
    ChartCardHeaderDataComponent,
  ],
  templateUrl: './teachers-report-chart.component.html',
  styleUrls: ['./teachers-report-chart.component.scss'],
})
export class TeachersReportChartComponent extends BaseComponent implements OnInit {
  form!: FilterFormGroup;
  headerData: ChartHeaderData[];
  chartfilters: chartFilters;
  caller: ChartCardCallerCallBack<BaseChart>;

  constructor(injector: Injector, private dashboardRepository: DashboardRepository) {
    super(['DASHBOARD'], injector, true);
  }

  ngOnInit(): void {
    this.initializeForm();
    this.onSearch();
  }

  private initializeForm(): void {
    this.form = new FilterFormGroup({
      dateRange: new FormControl(null),
    });
  }

  private onSearch(): void {
    this.form.formSubmitted.pipe(takeUntil(this.destroy$)).subscribe((emitted) => {
      if (emitted == 'reset') {
        this.form.reset();
      }
      this.chartfilters = { dateRange: this.form.get('dateRange').value };
      this.callCaller();
      this.injector.get(ChangeDetectorRef).detectChanges();
    });
  }

  private callCaller(): void {
    this.caller = () => {
      let dateRange = {
        fromDate: this.form.get('dateRange').value?.start ? new Date(this.form.get('dateRange').value?.start) : null,
        toDate: this.form.get('dateRange').value?.end ? new Date(this.form.get('dateRange').value?.end) : null,
      };
      return this.dashboardRepository.getActiveTeachersReport(dateRange).pipe(
        map((res) => {
          return this.constructChart(res);
        })
      );
    };
  }

  private constructChart(res: DashboardReportsCharts): BaseChart[] {
    const activeTeachersChart = new BaseChart(
      [res.countOfActiveMaleTeachers, res.countOfActiveFemaleTeachers],
      this.translationsList['DASHBOARD']['CHARTS']['ACTIVE'],
      this.currentThemeColors.PRIMARY_COLOR,
      null,
      [res.changeRateOfActiveMaleTeachers, res.changeRateOfActiveFemaleTeachers]
    );
    const blockedTeachersChart = new BaseChart(
      [res.countOfBlockedMaleTeachers, res.countOfBlockedFemaleTeachers],
      this.translationsList['DASHBOARD']['CHARTS']['BLOCKED'],
      this.currentThemeColors.GREY_COLOR_400
    );
    // const onlineTeachersChart = new BaseChart(
    //   [res.countOfOnlineMaleTeachers, res.countOfOnlineFemaleTeachers],
    //   this.translationsList['DASHBOARD']['CHARTS']['ONLINE'],
    //   this.currentThemeColors.ORANGE_COLOR
    // );
    const busyTeachersChart = new BaseChart(
      [res.countOfBusyMaleTeachers, res.countOfBusyFemaleTeachers],
      this.translationsList['DASHBOARD']['CHARTS']['BUSY'],
      this.currentThemeColors.GREY_COLOR_700
    );
    const chartData: BaseChart[] = [
      activeTeachersChart,
      blockedTeachersChart /*, onlineTeachersChart*/,
      busyTeachersChart,
    ];
    this.initializeChartHeader(chartData);
    return chartData;
  }

  private initializeChartHeader(chartData: BaseChart[]): void {
    const chart: BaseChart = chartData[0];
    this.headerData = [
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['ACTIVE'],
        count: chart.dataSet?.[0] + chart.dataSet?.[1],
      },
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['MALE'],
        count: chart.dataSet?.[0],
        changeRate: chart.changeRate?.[0],
      },
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['FEMALE'],
        count: chart.dataSet?.[1],
        changeRate: chart.changeRate?.[1],
      },
    ];
  }
}
